import { createWishList } from './CreateWishList/CreateWishList';
import { addItemToWishList } from './AddItemToWishList/AddItemToWishList';
import { APIResult } from './APIResult';
import { logAPIErrorToNewrelic } from './utils';

export const createWishListAndAddItem = async (
    skuId: string,
    itemDetails: object,
    productMetaData?: ProductMetadata,
): Promise<APIResult<ProductWishList[]>> => {
    const newWishList = await createWishList();
    if (!newWishList.success) {
        logAPIErrorToNewrelic('createWishListAndAddItem', 'Create: API returned Non OK', {
            skuId: skuId,
            productMetadata: productMetaData,
            response: newWishList,
            ...newWishList,
        });
        return new APIResult<ProductWishList[]>(newWishList);
    }

    if (!newWishList.data) {
        logAPIErrorToNewrelic('createWishListAndAddItem', 'Create: Unexpected data scenario | No Data', {
            skuId: skuId,
            productMetadata: productMetaData,
            response: newWishList,
            errorThrown: true,
            ...newWishList,
        });
        throw Error('Unexpected data scenario');
    }

    const newWishlistID = newWishList.data.id;

    const addResult = await addItemToWishList(newWishlistID, skuId, itemDetails, productMetaData);

    if (!addResult.success) {
        logAPIErrorToNewrelic('createWishListAndAddItem', 'Add: API returned Non OK', {
            ...addResult,
            skuId: skuId,
            productMetadata: productMetaData,
            wishList: newWishList,
            response: addResult,
        });
        return new APIResult<ProductWishList[]>(addResult);
    }

    if (!addResult.data) {
        logAPIErrorToNewrelic('createWishListAndAddItem', 'Add: Unexpected data scenario | No Data', {
            ...addResult,
            skuId: skuId,
            productMetadata: productMetaData,
            wishList: newWishList,
            response: addResult,
            errorThrown: true,
        });
        throw Error('Unexpected data scenario');
    }

    const updatedWishList = addResult.data;
    const wishLists: ProductWishList[] = [];
    let asafProperties: ASAFProperties | undefined = undefined;
    if (productMetaData) {
        asafProperties = updatedWishList.products[0].asafProperties;
    }

    wishLists.push({
        id: updatedWishList.id,
        isAdded: true,
        name: updatedWishList.name,
        isFull: false,
        products: [
            {
                skuId: skuId,
                asafProperties,
            },
        ],
    });

    const result = new APIResult<ProductWishList[]>();
    result.success = true;
    result.data = wishLists;
    return result;
};
